import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import RenewalsDashboard from './RenewalsDashboard'
import RenewalsList, { DEFAULT_LIST_FILTERS, RenewalsListFilters } from './RenewalsList'

type TabKey = 'dashboard' | 'list'

const Renewals: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('dashboard')
  const [filters, setFilters] = useState<RenewalsListFilters>(DEFAULT_LIST_FILTERS)

  const jumpToList = (partial: Partial<RenewalsListFilters>) => {
    // Reset to defaults before applying the partial — filters from a previous
    // jump or manual edit must not accumulate.
    setFilters({ ...DEFAULT_LIST_FILTERS, ...partial })
    setActiveTab('list')
  }

  return (
    <div>
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab((k as TabKey) ?? 'dashboard')}
        className="mb-0"
      >
        <Tab eventKey="dashboard" title="Dashboard">
          <RenewalsDashboard onJumpToList={jumpToList} />
        </Tab>
        <Tab eventKey="list" title="Customer List">
          <RenewalsList filters={filters} onFiltersChange={setFilters} />
        </Tab>
      </Tabs>
    </div>
  )
}

export default Renewals
